module.exports = __webpack_public_path__ + "static/media/closebtn.d13782dc.svg";